import React, { useEffect, useState } from "react";
import { Loader2, ChevronDown, ChevronRight, XCircle, FileText } from "lucide-react";
import { Breadcrumb, GradientPanel } from "../components/common";
import api from "../lib/api";

const tone = { ok: "bg-emerald-400", info: "bg-blue-400", warn: "bg-amber-400", error: "bg-rose-400" };

const StatusTrace = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(null);

  const load = async () => { setLoading(true); try { const { data } = await api.get("/invoices"); setRows(data); } catch {} finally { setLoading(false); } };
  useEffect(() => { load(); }, []);

  const cancel = async (id) => { try { await api.post(`/invoices/${id}/cancel`); load(); } catch {} };

  return (
    <div>
      <Breadcrumb items={[{ label: "Dashboard", path: "/a/dashboard" }, { label: "Status & Trace" }]} />
      <GradientPanel>
        <h1 className="text-2xl font-bold text-gray-900">Status &amp; Trace</h1>
        <p className="text-sm text-gray-500 mt-1">Track every document corner-by-corner (C1->C5) with TDD / MLS logs. Cancel from here.</p>
        {loading ? <div className="py-16 flex justify-center"><Loader2 className="animate-spin text-indigo-500" size={26} /></div> : rows.length === 0 ? (
          <div className="py-16 text-center text-gray-400"><FileText size={30} className="mx-auto mb-2" />No documents yet.</div>
        ) : (
          <div className="mt-5 space-y-2">
            {rows.map((r) => (
              <div key={r.id} className="border border-gray-100 rounded-xl overflow-hidden">
                <button onClick={() => setOpen(open === r.id ? null : r.id)} className="w-full flex items-center gap-3 px-4 py-3 hover:bg-gray-50 text-left">
                  {open === r.id ? <ChevronDown size={16} className="text-gray-400" /> : <ChevronRight size={16} className="text-gray-400" />}
                  <span className="font-medium text-gray-800 w-44">{r.number}</span>
                  <span className="text-sm text-gray-500 flex-1 truncate">{r.buyer?.name} · {r.scenario_label}</span>
                  <span className="text-sm text-indigo-600">{r.totals.tax.toFixed(2)} {r.currency}</span>
                  <span className={`text-[11px] font-semibold px-2 py-0.5 rounded ${r.status === "Cancelled" ? "text-rose-600 bg-rose-50" : "text-emerald-600 bg-emerald-50"}`}>{r.status}</span>
                </button>
                {open === r.id && (
                  <div className="px-5 pb-4 pt-1 bg-gray-50/50">
                    <div className="flex flex-wrap gap-x-8 gap-y-1 text-xs text-gray-500 mb-3">
                      <span>Type: <b className="text-gray-700 capitalize">{(r.doc_type || "invoice").replace("_", " ")}</b></span>
                      <span>FTA: <b className="text-gray-700">{r.fta_id}</b></span>
                      <span>Channel: <b className="text-gray-700">{r.channel}</b></span>
                      {r.backdated && <span className="text-amber-600 font-semibold">BACKDATED</span>}
                      {r.reference_number && <span>Ref: <b className="text-gray-700">{r.reference_number}</b></span>}
                    </div>
                    <div className="space-y-1.5">
                      {(r.status_history || []).map((ev, i) => (
                        <div key={i} className="flex items-center gap-3 text-xs">
                          <span className="font-bold text-gray-500 w-8">{ev.corner}</span>
                          <span className={`w-2 h-2 rounded-full ${tone[ev.status] || "bg-gray-300"}`} />
                          <span className="text-gray-600 flex-1">{ev.label}</span>
                          <span className="text-gray-300">{new Date(ev.ts).toLocaleTimeString()}</span>
                        </div>
                      ))}
                    </div>
                    {r.status !== "Cancelled" && (
                      <button onClick={() => cancel(r.id)} className="mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-rose-600 border border-rose-200 hover:bg-rose-50 px-3 py-1.5 rounded-lg transition"><XCircle size={14} /> Cancel e-invoice</button>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </GradientPanel>
    </div>
  );
};

export default StatusTrace;
